import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[mrsoftappsProjectReferenceFormView]'
})
export class ProjectReferenceFormDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
